// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum FanOperationType {
    Automatic = 0,
    Off = 1,
    On = 2,
}
export default FanOperationType;
